import moment from 'moment';
import momentDurationFormatSetup from 'moment-duration-format';

momentDurationFormatSetup(moment);

export function formatDuration(seconds) {
  return moment.duration(seconds, 'minutes').format('h[h] m[m]');
}

const currencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD'
});

export function formatCurrency(value) {
  return currencyFormat.format(value).replace(/^(\D+)/, '$1 ');
}
